import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {BillingService} from '../../service/billing/billingService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {attachWorkspaceFilterState} from '../../utils/workspaceStateUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';
import {BaseComponent} from '../basecomponent.js';


/* global customElements */
class AccountGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();		
		
		var accountGrid = this;
		setTimeout(function(){
			accountGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var accountGrid = this;
		
		var filterSearch = true;		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{	
					tag: 'vaadin-combo-box',
					label: 'Filter Field',
					itemid: 'filterField',
					'item-value-path': 'code',
					'item-label-path': 'description',
					style: 'margin-left: 10px;',
					required: true,
					value: 'companyName',
					postinit: function (combo) {
						combo.items = [
							{
								code: 'companyName',
								description: 'Company Name'
							},
							{
								code: 'referenceCode',
								description: 'Reference Code'
							},
							{
								code: 'carrierId',
								description: 'Carrier Id'
							},
							{
								code: 'billingCycleDay',
								description: 'Billing Cycle Day'
							},
							{
								code: 'paymentType',
								description: 'Payment Type'								
							}
						];						
					}
				},				
				{
					tag: 'vaadin-text-field',
					itemid: 'filterValue',
					'class': 'spacer-toolbar-item',
					'keep-open': true,
					label: 'Filter By',
					required: true,
					listeners: {
						input: {
							fn: function() {
								if (filterSearch) {
									actionSearch();																		
								} else {
									filterSearch = true;
								}
							},
							buffer: 2000
						}
					}
				},			
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',						
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					label: 'Status',
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					}										
				},
				{
					tag: 'vaadin-button',
					itemid: 'search',
					theme: 'primary',
					'class': 'spacer-toolbar-item',				
					children:[
						ElementUtil.makeIcon('vaadin:search', ' Search')
					],
					listeners: {
						click: function() {	
							filterSearch = false;
							actionSearch();
						}
					}					
				},
				{
					tag: 'span',
					style: 'font-size: 24px; color: gray;',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'view',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_BILLING_ACCOUNTS:READ'],
					children:[
						ElementUtil.makeIcon('lumo:eye', ' Manage')
					],
					listeners: {
						click: function() {							
							actionViewAccount(grid.selectedItems[0]);
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'purge',
					'class': 'spacer-toolbar-item',
					theme: 'error',
					disabled: true,
					permissions: ['ADMIN_BILLING_ACCOUNTS:PURGE_INCOMPLETE_ACCOUNT'],
					children:[
						ElementUtil.makeIcon('vaadin:trash', ' Purge Incomplete')
					],
					listeners: {
						click: function() {
							actionPurgeIncomplete(grid.selectedItems[0]);
						}
					}
				}
			]
		});	
		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}				
			},			
			children: [	
				{						
					path: 'companyId',
					header: 'Company Id',					
					width: '7em'
				},
				{						
					path: 'companyName',
					header: 'Company Name',					
					'flex-grow': '1'
				},				
				{						
					path: 'accountStatus',
					header: 'Account Status',
					width: '9em',
					'text-align': 'center',
					renderer: function(root, column, rowData) {
						if (rowData.item.accountStatusDescription) {
							root.innerHTML = rowData.item.accountStatusDescription;
						} else {
							root.innerHTML = 'N/A';
						}
					}
				},				
				{						
					path: 'lastCycleDate',
					header: 'Last/Next Cycle Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = TimeUtil.formatBillingCalendarDate(rowData.item.lastCycleDate);					
					}
				},
				{						
					path: 'nextCycleDate',
					header: 'Next Cycle Date',					
					width: '7em',
					renderer: function(root, column, rowData) {
						root.innerHTML = TimeUtil.formatBillingCalendarDate(rowData.item.nextCycleDate);					
					}
				},				
				{						
					path: 'currentBalance',
					header: 'Balance',						
					width: '9em',
					'text-align': 'end',
					renderer: function(root, column, rowData) {
						root.innerHTML = StringUtil.currencyFormat(rowData.item.currentBalance);					
					}
				}				
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {												
						ElementUtil.query(toolbar, 'view').disabled = false;
						ElementUtil.query(toolbar, 'purge').disabled = !!item.accountStatus;
					} else {												
						ElementUtil.query(toolbar, 'view').disabled = true;
						ElementUtil.query(toolbar, 'purge').disabled = true;
					}	
				},
				'dblclick' : function (event) {
					if (grid.selectedItems[0]) {
						actionViewAccount(grid.selectedItems[0]);
					}
				}
			}
		});		
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 200,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
					
					accountGrid.currentFilter = {
						offset: pageRange.offset,
						max: pageRange.max,
						sortField: backingGrid.currentSortField,
						sortOrder: backingGrid.currentSortDirection,
						status: ElementUtil.query(toolbar, 'status').value,
						filterField: ElementUtil.query(toolbar, 'filterField').value,
						filterValue: ElementUtil.query(toolbar, 'filterValue').value
					};
					
					var successHandler = function(records) {
						loadMask.remove();
						grid.activeItem = null;						
						grid.items = records.data;
						
						accountGrid.fullDataSet = records.data;						
						pagingToolbar.totalRecords = records.totalNumber;
						pagingToolbar.updatePager();						
					};
					
					BillingService.getAccountService()
					.getAccounts(accountGrid.currentFilter)
					.then(function(records){							
						successHandler(records);
					});
										
				};
			},
			listeners: {
				ready: function() {					
					//pagingToolbar.loadCurrentPage();
				}
			}
			
		});		
		
		var searchResultsLabel = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			style: 'padding: 6px 10px 2px 10px; color: var(--lumo-secondary-text-color); font-size: var(--lumo-font-size-s);',
			innerHTML: 'Search Results'
		});

		var footer = ExportUtil.createExportFooter({
			pagingToolbar: pagingToolbar,
			grid: grid,
			itemid: 'accounts',
			onDetail: function() {
				ExportUtil.exportGridItemsAsCsv(grid.items, 'accounts.csv');
			}
		});

		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				searchResultsLabel,
				grid,
				footer.footerContainer
			]
		});		
		accountGrid.append(flexLayout);		
		
		
		var actionSearch = function() {
			var filterValueField = ElementUtil.query(toolbar, 'filterValue');
			if (filterValueField.value) {
				pagingToolbar.loadPage(1);			
			} else {
				filterValueField.validate();
			}
		};
		attachWorkspaceFilterState(accountGrid, toolbar, ['filterField','filterValue','status'], actionSearch);
		
		var actionPurgeIncomplete = function(record) {
			if (!record || record.accountStatus) {
				window.DL.MessageUtil.showToast('Not Allowed', 'Purge is only for Missing Account rows. Use Close Account for complete accounts.', {
					theme: 'error'
				});
				return;
			}
			var companyLabel = record.companyName || record.companyId;
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Purge Incomplete Account',
				message: 'Permanently delete incomplete company <b>' + companyLabel + '</b>?<br><br>'
						+ 'This removes the company shell for Missing Account rows and cannot be undone.<br>'
						+ 'If this company has a working billing account, cancel and use Close Account instead.',
				buttons: [
					{
						text: 'Yes, Purge',
						handler: function() {
							var loadMask = grid.showLoading('Purging incomplete account...');
							BillingService.getAccountService().purgeIncompleteAccount(record.companyId).then(function() {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Purged incomplete account: ' + companyLabel, {
									theme: 'success'
								});
								actionSearch();
							}).catch(function() {
								loadMask.remove();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
		};

		var actionViewAccount = function(record) {
			
			var manageWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Manage Account',
				icon: 'vaadin:suitcase',
				listeners: {
					ready: function() {						
						manageWin.show();
						
						
						var loadMask = manageWin.showLoading('Loading Account Details...');
						BillingService.getAccountService().getAccountDetails(record.companyId).then(function(detail) {
							loadMask.remove();
							
							detail.searchRecord = record;

							var tabPanel = ElementUtil.create({
								tag: 'dl-tabpanel',
								listeners: {
									ready: function(e) {									
										tabPanel.addTabs([
											{
												'tab-title': 'Account Info',
												itemid: 'account-info',
												tag: 'div',
												style: 'height: 100%;',
												children: [
													{
														tag: 'dl-flex-layout',
														children: [
															{
																tag: 'dl-toolbar',
																slot: 'toolbar',
																theme: 'spacing',
																children: [
																	{
																		tag: 'vaadin-button',
																		itemid: 'refresh',
																		'class': 'spacer-toolbar-item',
																		children:[
																			ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
																		], 
																		listeners: {
																			click: function() {
																				var accountLoadMask = ElementUtil.query(tabPanel, 'account-info').showLoading();
																				BillingService.getAccountService().getAccountDetails(record.companyId).then(function(accountDetail) {
																					accountLoadMask.remove();
																					ElementUtil.query(tabPanel, 'generalInfo').updateInfo(accountDetail);	
																				});
																			}
																		}
																	}
																]																
															},
															{
																tag: 'dl-account-general-info',
																itemid: 'generalInfo',
																slot: 'primary',
																listeners: {
																	ready: function() {
																		ElementUtil.query(tabPanel, 'generalInfo').updateInfo(detail);
																	}
																}
															}
														]
													}
												]									
											},
											{
												'tab-title': 'Comments',
												tag: 'div',
												style: 'height: 100%;',
												children: [	
													{
														tag: 'dl-account-comment-grid',
														properties: {
															detail: detail
														} 
													}
												]									
											},
											{
												'tab-title': 'Products',
												tag: 'div',
												style: 'height: 100%;',
												children: [	
													{
														tag: 'dl-account-order-grid',
														properties: {
															detail: detail
														}
													}
												]									
											},
											{
												'tab-title': 'Invoices',
												tag: 'div',
												style: 'height: 100%;',
												children: [	
													{
														tag: 'dl-account-invoice-grid',
														properties: {
															detail: detail
														}
													}
												]									
											},
											{
												'tab-title': 'Payments',
												tag: 'div',
												style: 'height: 100%;',
												children: [	
													{
														tag: 'dl-account-payment-grid',
														properties: {
															detail: detail
														}
													}
												]									
											},
											{
												'tab-title': 'Adjustments',
												tag: 'div',
												style: 'height: 100%;',
												children: [
													{
														tag: 'dl-account-adjustment-grid',
														properties: {
															detail: detail
														}
													}													
												]									
											},
											{
												'tab-title': 'Factoring Setup',
												tag: 'div',
												style: 'height: 100%;',
												children: [	
													{
														tag: 'dl-account-factoring-grid',
														properties: {
															detail: detail
														}
													}													
												]									
											},
											{
												'tab-title': 'Contracts',
												tag: 'div',
												style: 'height: 100%;',
												children: [		
													{
														tag: 'dl-account-contract-grid',
														properties: {
															detail: detail
														}
													}
												]									
											},
											{
												'tab-title': 'Billing Setup',
												tag: 'div',
												style: 'height: 100%;',
												children: [
													{
														tag: 'dl-account-billing-preferences',
														properties: {
															detail: detail
														}
													}
												]									
											},
											{
												'tab-title': 'Account Management',
												tag: 'div',												
												children: [	
													{
														tag: 'dl-account-account-control',
														properties: {
															detail: detail
														}
													}
												]									
											}
										]);

									}
								}
							});

							manageWin.addToContentElement(tabPanel);	
													
							
						});
						
					}
				}
			});
			
			
						
		};		


	}
	
};
customElements.define('dl-account-grid', AccountGrid);